import { Link } from 'react-router-dom';
import { customizableWatches } from '../../mocks/customizable-watches';

const CSV_CONTENT = `product_id,product_name,short_name,description,base_price,image_url,case_material_options,bezel_type_options,dial_color_options,hands_options,bracelet_strap_options,movement_options,pushers_options,subdial_layout_options,crown_guards_options,case_shape_options,bracelet_integration_options,day_display_options
custom-sub-gmt,Create Your Own Sub/GMT,Sub/GMT,"Design your perfect dive watch with GMT functionality. Choose from premium materials, bezel styles, and movement options to create a timepiece built for adventure.",2499,https://static.readdy.ai/image/64f7aba38830139cff78662b39218feb/a6250d97b72664656b60e264d017d709.png,"Stainless Steel | Titanium | Two-Tone | Yellow Gold | Rose Gold","Ceramic Black | Ceramic Blue | Ceramic Green | Aluminum Pepsi | Aluminum Batman","Black | Blue | Green | White | Sunburst Silver","Mercedes | Sword | Snowflake | Dauphine","Oyster Bracelet | Jubilee Bracelet | Rubber Strap | NATO Strap | Leather Strap","Automatic | GMT Automatic | High-Beat Automatic",,,,,,
custom-chronograph,Create Your Own Chronograph,Chronograph,"Build your ultimate racing-inspired chronograph. Select case materials, pusher styles, subdial configurations, and more for precision timing in style.",2899,https://static.readdy.ai/image/64f7aba38830139cff78662b39218feb/3a0dd30d05593d74ebbd1728c4abc28b.png,"Stainless Steel | Titanium | Rose Gold | Platinum | Carbon Fiber",,"Black | White Panda | Blue | Silver | Carbon",,"Steel Bracelet | Racing Leather | Rubber Strap | Alligator Strap","Automatic Chronograph | Manual Chronograph | High-Frequency Chronograph","Round Pushers | Rectangular Pushers | Screw-Down Pushers","Tri-Compax | Bi-Compax | Mono-Pusher",,,,
custom-44mm-diver,Create Your Own 44mm Diver,44mm Diver,"Craft your professional dive watch with a bold 44mm case. Choose materials, bezel options, and water resistance features for the ultimate underwater companion.",2699,https://static.readdy.ai/image/64f7aba38830139cff78662b39218feb/69ea43b56ce12499ca506cc38eaec880.png,"Stainless Steel | Titanium | Bronze | Black DLC | Two-Tone","Ceramic Black | Ceramic Blue | Ceramic Orange | Aluminum Silver | Sapphire Insert","Black | Blue | Orange | Green | White","Sword | Arrow | Plongeur | Baton","Steel Bracelet | Rubber Dive Strap | NATO Strap | Mesh Bracelet","Automatic 300m | Automatic 500m | High-Beat 1000m",,,,,,
custom-datejust,Create Your Own Datejust,Datejust,"Design your classic dress watch with date function. Select from elegant materials, dial patterns, and bracelet styles for timeless sophistication.",3199,https://static.readdy.ai/image/64f7aba38830139cff78662b39218feb/28f39ec9800741bd8940d5d323cc480f.png,"Stainless Steel | Two-Tone | Yellow Gold | White Gold | Everose Gold","Smooth | Fluted | Diamond | Engine-Turned","Champagne | Blue Sunburst | Black | Silver | Slate | Wimbledon","Dauphine | Baton | Roman | Diamond","Jubilee Bracelet | Oyster Bracelet | President Bracelet | Leather Strap","Automatic Date | Perpetual Automatic | COSC Certified",,,,,,
custom-santos,Create Your Own Santos,Santos,"Build your iconic square aviation watch. Choose case finishes, bezel screws, dial styles, and integrated bracelet options for a distinctive look.",3499,https://static.readdy.ai/image/64f7aba38830139cff78662b39218feb/e1fbf8692233df6830a306be644c3744.png,"Stainless Steel | Two-Tone | Rose Gold | Yellow Gold | ADLC Black",,"Silver | Blue | Black | Skeleton | Roman Numerals","Sword Blue | Sword Black | Baton | Skeleton","Automatic | Skeleton Automatic | Manual Wind",,,,,"Large 39mm | Medium 35mm | Extra Large 43mm","Steel Integrated | Two-Tone Integrated | Leather Quick-Switch | Rubber Quick-Switch",
custom-nautilus,Create Your Own Nautilus,Nautilus,"Create your luxury sports watch with distinctive porthole design. Select premium materials, dial textures, and integrated bracelet styles.",3999,https://static.readdy.ai/image/64f7aba38830139cff78662b39218feb/cee8eab2b1be96dd846fdfae49c3ddff.png,"Stainless Steel | Two-Tone | Rose Gold | White Gold | Platinum",,"Blue Horizontal | Black Horizontal | White Horizontal | Brown Horizontal | Olive Green","Baton Luminous | Dauphine | Skeleton","Ultra-Thin Automatic | Automatic Date | Automatic Power Reserve",,,,,,,"Steel Integrated | Two-Tone Integrated | Gold Integrated | Leather Strap | Rubber Strap",
custom-oak,Create Your Own Oak,Royal Oak,"Design your octagonal luxury sports watch. Choose from premium materials, tapisserie dial patterns, and iconic integrated bracelet options.",4299,https://static.readdy.ai/image/64f7aba38830139cff78662b39218feb/568d14ec4aab7ed96275a3a3b9800ab5.png,"Stainless Steel | Two-Tone | Rose Gold | Yellow Gold | Titanium | Ceramic",,"Blue Tapisserie | Black Tapisserie | Silver Tapisserie | Grey Tapisserie | Salmon","Baton Luminous | Royal Oak Signature | Skeleton","Ultra-Thin Automatic | Automatic Chronograph | Perpetual Calendar",,,,,,,"Steel Integrated | Two-Tone Integrated | Gold Integrated | Rubber Strap",
custom-daydate,Create Your Own Day-Date,Day-Date,"Build your presidential watch with day and date display. Select precious metals, dial styles, and the iconic president bracelet for ultimate prestige.",4599,https://static.readdy.ai/image/64f7aba38830139cff78662b39218feb/d16204d14c3098e795c681dc4c18301d.png,"Yellow Gold | White Gold | Everose Gold | Platinum","Fluted | Smooth | Diamond | Baguette Diamond","Champagne | Blue Sunburst | Green Ombre | Chocolate | Ice Blue | Olive Green","Dauphine | Baton | Roman | Diamond","President Bracelet | Oyster Bracelet | Leather Strap","Perpetual Automatic | COSC Certified | Master Chronometer",,,,,,,"English | Arabic | Chinese | French | Spanish"`;

function downloadCSV() {
  const blob = new Blob([CSV_CONTENT], { type: 'text/plain;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'zakeke-products.csv';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export default function CollectionsPage() {
  return (
    <div className="min-h-screen bg-white pt-20">
      {/* Hero Section */}
      <div className="relative h-[400px] bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Watch Customizer
          </h1>
          <p className="text-xl text-gray-200 leading-relaxed">
            Design your perfect timepiece from our exclusive collection. Each watch offers unique customization options to create a truly personal masterpiece.
          </p>
          {/* Zakeke CSV Download */}
          <button
            onClick={downloadCSV}
            className="mt-8 inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/30 text-white px-5 py-2.5 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-download-2-line"></i>
            </div>
            Download Zakeke CSV
          </button>
        </div>
      </div>

      {/* Collection Grid */}
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {customizableWatches.map((watch) => (
            <div
              key={watch.id}
              className="group bg-white rounded-lg overflow-hidden border border-gray-200 hover:border-gray-300 transition-all duration-300 hover:shadow-xl"
            >
              {/* Watch Image */}
              <div className="relative h-80 bg-gradient-to-br from-gray-50 to-gray-100 overflow-hidden">
                <img
                  src={watch.image}
                  alt={watch.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 bg-black/80 text-white px-3 py-1 rounded-full text-sm font-medium">
                  From ${watch.basePrice.toLocaleString()}
                </div>
              </div>

              {/* Watch Info */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-gray-700 transition-colors">
                  {watch.name}
                </h3>
                <p className="text-sm text-gray-600 mb-4 line-clamp-3">
                  {watch.description}
                </p>

                {/* Customization Options Preview */}
                <div className="mb-4 pb-4 border-b border-gray-200">
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                    Customize:
                  </p>
                  <div className="flex flex-wrap gap-1">
                    {Object.keys(watch.customizationOptions).slice(0, 3).map((option) => (
                      <span
                        key={option}
                        className="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded-md"
                      >
                        {option.replace(/([A-Z])/g, ' $1').trim()}
                      </span>
                    ))}
                    {Object.keys(watch.customizationOptions).length > 3 && (
                      <span className="text-xs text-gray-500 px-2 py-1">
                        +{Object.keys(watch.customizationOptions).length - 3} more
                      </span>
                    )}
                  </div>
                </div>

                {/* Customize Button */}
                <Link
                  to={watch.customizerLink}
                  className="block w-full bg-black text-white text-center py-3 rounded-lg font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Customize Now
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Info Section */}
      <div className="bg-gradient-to-br from-gray-50 to-gray-100 py-16">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            Your Watch, Your Way
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-8">
            Each customizable watch in our collection offers a unique set of options tailored to its design heritage. From case materials and dial colors to movement types and bracelet styles, every detail can be personalized to match your vision.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
            <div className="text-center">
              <div className="w-16 h-16 bg-black text-white rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-settings-3-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Endless Options</h3>
              <p className="text-sm text-gray-600">
                Thousands of combinations to create your perfect timepiece
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-black text-white rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-eye-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Live Preview</h3>
              <p className="text-sm text-gray-600">
                See your customizations in real-time as you design
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-black text-white rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-star-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Premium Quality</h3>
              <p className="text-sm text-gray-600">
                Every watch is crafted with the finest materials
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}